type CallableLikeError = {
  code?: unknown;
  message?: unknown;
  details?: unknown;
};

export function getFunctionsErrorCode(error: unknown): string | undefined {
  if (!error || typeof error !== "object") {
    return undefined;
  }
  const code = (error as CallableLikeError).code;
  return typeof code === "string" ? code : undefined;
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (!error || typeof error !== "object") {
    return String(error ?? "");
  }
  const message = (error as CallableLikeError).message;
  return typeof message === "string" ? message : "";
}

export function isInsufficientTokensError(error: unknown): boolean {
  const code = getFunctionsErrorCode(error);
  if (code === "functions/resource-exhausted") {
    return true;
  }
  return getErrorMessage(error).toLowerCase().includes("insufficient tokens");
}

export function isSubscriptionRequiredError(error: unknown): boolean {
  const code = getFunctionsErrorCode(error);
  if (code !== "functions/failed-precondition") {
    return false;
  }
  return getErrorMessage(error).toLowerCase().includes("subscription");
}
